/* eslint-disable */
import syncTokens from "@amzn/meridian-tokens/base/icon/sync";
import undoTokens from "@amzn/meridian-tokens/base/icon/undo";
import refreshTokens from "@amzn/meridian-tokens/base/icon/refresh";
import expandTokens from "@amzn/meridian-tokens/base/icon/expand";
import cameraTokens from "@amzn/meridian-tokens/base/icon/camera";
import userTokens from "@amzn/meridian-tokens/base/icon/user";
import chevronDownSmallTokens from "@amzn/meridian-tokens/base/icon/chevron-down-small";
import chevronRightSmallTokens from "@amzn/meridian-tokens/base/icon/chevron-right-small";
import React from "react";
import Column from "@amzn/meridian/column";
import Button from "@amzn/meridian/button";
import Row from "@amzn/meridian/row";
import Icon from "@amzn/meridian/icon";
import Box from "@amzn/meridian/box";
import Input from "@amzn/meridian/input";
import Toaster from "@amzn/meridian/toaster";
import Alert from "@amzn/meridian/alert";
import Expander from "@amzn/meridian/expander";
import Table, { TableRow, TableCell } from "@amzn/meridian/table";
import Select, { SelectOption } from "@amzn/meridian/select";
import Checkbox from "@amzn/meridian/checkbox";
import Divider from "@amzn/meridian/divider";
import Text from "@amzn/meridian/text";

import "./dev-support.css";

import { AppContext } from "./context/app-context";
import { VSAContext } from "./context/vsa-context";
import { DevContext } from "./context/dev-context";
import { checkVin, InputVinStateEnum } from "./utils/check-vin";
import STRINGS from "./locale/strings";
import { ROUTE_PATH } from "./routing";

const TOASTER_TIMEOUT = 5000;
const ENVS = ["beta", "gamma", "prod"];
const REGIONS = ["NA", "EU", "FE", "IN"];
const LOCALE_MAP = {
  en: "English",
  de: "German",
  es: "Spanish",
  fr: "French",
  hi: "Hindi",
  it: "Italian",
  ja: "Japanese",
  pt: "Portuguese",
  ro: "Romanian",
  nl: "Dutch",
  tr: "Turkish",
  ar: "Arabic",
};
const INSPECTION_TYPE = {
  operational: "Operational",
  grounded: "Grounded",
  ready_for_audit: "Ready for audit",
};

/* returns true for mobile devices*/
export function isMobile() {
  let check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(
        a.substr(0, 4)
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
}

/* View in fullscreen */
function openFullscreen() {
  if (document.body.requestFullscreen) {
    document.body.requestFullscreen();
  } else if (document.body.webkitRequestFullscreen) {
    /* Safari */
    document.body.webkitRequestFullscreen();
  } else if (document.body.msRequestFullscreen) {
    /* IE11 */
    document.body.msRequestFullscreen();
  }
}

/* Close fullscreen */
function closeFullscreen() {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.webkitExitFullscreen) {
    /* Safari */
    document.webkitExitFullscreen();
  } else if (document.msExitFullscreen) {
    /* IE11 */
    document.msExitFullscreen();
  }
}

export const withDevSupport = (actualUI) => {
  if (isMobile()) {
    return actualUI;
  }

  return <DevSupport actualUI={actualUI} />;
};

const DevSupport = ({ actualUI }) => {
  const { appState, formatMessage } = React.useContext(AppContext);
  const { vsaState } = React.useContext(VSAContext);
  const { devState, devActions } = React.useContext(DevContext);

  const [isDebugDataOpen, setIsDebugDataOpen] = React.useState(false);
  const [expandedRows, setExpandedRows] = React.useState([]);
  const [isFullScreen, setFullScreen] = React.useState(false);
  const [action, setAction] = React.useState(null);
  const [accessToken, setAccessToken] = React.useState("");
  const [scannedText, setScannedText] = React.useState("");
  const [scannedTextError, setScannedTextError] = React.useState(false);
  const [scannedTextErrorMessage, setScannedTextErrorMessage] =
    React.useState("");

  const updateExpandedRows = (row) => {
    const newExpandedRows = expandedRows.includes(row)
      ? expandedRows.filter((expandedRow) => expandedRow !== row)
      : [...expandedRows, row];

    setExpandedRows(newExpandedRows);
  };

  const [toasts, setToasts] = React.useState([]);
  const onCloseToast = (id) => setToasts(toasts.filter((t) => t.id !== id));
  const showToast = (message) =>
    setToasts(
      toasts.concat({
        id: `${new Date().getTime()}`,
        timeout: TOASTER_TIMEOUT,
        message: message,
      })
    );

  const handleScannedTextOnChange = (event) => {
    const state = checkVin(event);

    switch (state) {
      case InputVinStateEnum.LENGTH_NOT_MATCH:
        setScannedTextError(true);
        setScannedTextErrorMessage(
          formatMessage(STRINGS.vsa_vin_length_not_match_warning)
        );
        break;
      case InputVinStateEnum.INVALID_CHARACTER:
        setScannedTextError(true);
        setScannedTextErrorMessage(
          formatMessage(STRINGS.vsa_vin_special_char_warning)
        );
        break;
      case InputVinStateEnum.VALID:
        setScannedTextError(false);
        setScannedTextErrorMessage("");
        break;
      case InputVinStateEnum.EMPTY:
        setScannedTextError(false);
        setScannedTextErrorMessage("");
        break;
    }

    setScannedText(event);
  };

  const onVinTextEntered = () => {
    if (!scannedText) {
      showToast(`You cannot send an empty scan.`);
      return;
    }

    devActions.updateScannedVin(scannedText);
    showToast(`Scanned event sent with value: ${scannedText}.`);
    setScannedText("");
  };

  const changeAppLocale = (value) => {
    devActions.updateDevLocale(value);
    showToast(`Locale changed to ${LOCALE_MAP[value]}.`);
  };

  const onUpdateMockApi = (boolean) => {
    if (boolean) {
      devActions.setMockApiTrue();
      showToast(
        `API mocking has been ENABLED. No calls to KITT will take place!`
      );
    } else {
      devActions.setMockApiFalse();
      showToast(
        `API mocking has been DISABLED. Calls to KITT will take place!`
      );
    }
  };

  const handleInspectionTypeChange = (event) => {
    devActions.updateInspectionType(event);
  };

  React.useEffect(() => {
    if (actualUI !== undefined) {
      devActions.setDevModeTrue();

      //Set mock api by default on init
      devActions.setMockApiTrue(true);
      showToast(
        `API mocking is ENABLED by default in DevTools. No calls to KITT will take place!`
      );
    }
  }, []);

  return (
    <Column className="container" spacingInset="medium" spacing="none">
      <Text type="h300" alignment="center">
        DevTools enabled for browser view
      </Text>
      <Row spacingInset="medium" alignmentHorizontal="center">
        <Column className="smartphone content">
          <Column
            className="scrollable-container"
            height="100%"
            overflowY="scroll"
          >
            {actualUI}
          </Column>
        </Column>
        <Toaster
          alignmentHorizontal={"right"}
          toasts={toasts}
          onCloseToast={onCloseToast}
        >
          {(toast) => (
            <Alert toast={true} onClose={toast.onClose}>
              {toast.message}
            </Alert>
          )}
        </Toaster>
        <Column>
          <Row alignmentVertical={"top"}>
            <Column
              alignmentHorizontal={"center"}
              spacingInset={"medium"}
              spacing={"none"}
            >
              <Button
                type={action === "start" ? "primary" : "secondary"}
                label={"start afresh"}
                onClick={() => {
                  if (action === "start") {
                    sessionStorage.clear();
                    window.location.href = "/";
                  } else {
                    setAction("start");
                    setTimeout(() => setAction(null), 1000);
                  }
                }}
              >
                &nbsp;
                <Icon tokens={syncTokens} />
                &nbsp;
              </Button>
              Start Afresh
              <Box spacingInset={"medium"} />
              <Button
                type={action === "reload" ? "primary" : "secondary"}
                label={"reload the page"}
                onClick={() => {
                  if (action === "reload") {
                    window.location.reload();
                  } else {
                    setAction("reload");
                    setTimeout(() => setAction(null), 1000);
                  }
                }}
              >
                &nbsp;
                <Icon tokens={refreshTokens} />
                &nbsp;
              </Button>
              Refresh Page
              <Box spacingInset={"medium"} />
              <Button
                label={"go or exit fullscreen"}
                onClick={() => {
                  if (!isFullScreen && document.fullscreenEnabled) {
                    openFullscreen();
                  }
                  if (isFullScreen) {
                    closeFullscreen();
                  }
                  setFullScreen(!isFullScreen);
                }}
              >
                &nbsp;
                <Icon tokens={expandTokens} />
                &nbsp;
              </Button>
              {!isFullScreen ? "Toggle Fullscreen" : "Close Fullscreen"}
              <Box spacingInset={"medium"} />
              <Button
                label={"go back"}
                onClick={() => {
                  window.dispatchEvent(new Event("BACK_PRESSED"));
                }}
              >
                &nbsp;
                <Icon tokens={undoTokens} />
                &nbsp;
              </Button>
              Go Back
            </Column>
            <Column
              spacingInset={"medium"}
              spacing={"small"}
              alignmentVertical={"top"}
              width={400}
            >
              <Text>Locale:</Text>
              <Select value={devState.devLocale} onChange={changeAppLocale}>
                {Object.keys(LOCALE_MAP).map((locale) => (
                  <SelectOption
                    key={locale}
                    value={locale}
                    label={LOCALE_MAP[locale]}
                  />
                ))}
              </Select>
              <Divider />
              {window.location.hash.slice(1) === ROUTE_PATH.SCAN_VIN.PATH && (
                <Column>
                  <Alert size="medium">
                    Use the field below to simulate the IR vin scanning proccess
                  </Alert>
                  <Row
                    spacingInset="300 none"
                    alignmentHorizontal="justify"
                    alignmentVertical="top"
                    maxWidth="100%"
                  >
                    <Column width="100%">
                      <Input
                        placeholder={"Scan VIN"}
                        id={"scanVIN"}
                        type="text"
                        autoFill={true}
                        size="medium"
                        value={scannedText}
                        onChange={handleScannedTextOnChange}
                        error={scannedTextError}
                        errorMessage={scannedTextErrorMessage}
                      />
                    </Column>
                    <Button
                      label={"scan"}
                      onClick={onVinTextEntered}
                      disabled={
                        !location.hash.includes("#/scan-vin") ||
                        scannedTextError
                      }
                    >
                      &nbsp;
                      <Icon tokens={cameraTokens} />
                      &nbsp;
                    </Button>
                  </Row>

                  <Divider />
                </Column>
              )}
              {(window.location.hash.slice(1) === ROUTE_PATH.SCAN_VIN.PATH ||
                window.location.hash.slice(1) ===
                  ROUTE_PATH.MANUAL_VIN_INPUT.PATH) && (
                <Column>
                  <Alert size="medium">
                    Select the type of inspection you want to use for mocking
                    the call
                  </Alert>
                  <Select
                    value={devState.inspectionType}
                    onChange={handleInspectionTypeChange}
                  >
                    {Object.keys(INSPECTION_TYPE).map((type) => (
                      <SelectOption
                        key={type}
                        value={type}
                        label={INSPECTION_TYPE[type]}
                      />
                    ))}
                  </Select>
                  <Divider />
                </Column>
              )}

              <Checkbox checked={devState.mockApi} onChange={onUpdateMockApi}>
                API mocking
              </Checkbox>
            </Column>
          </Row>
        </Column>
      </Row>
    </Column>
  );
};
